/**
 * 待办与审批（跨业务类型）
 *
 * 页面本体在 `components/ApprovalBoard.tsx`——合同、费用申请、报销单与发票的待办
 * 共用一套审批机制，抄两份的代价是**授权与动作规则会分叉**。
 *
 * 【为什么同一个人常常要来这里】财务初审、领导、租户管理员往往既审合同又审报销，
 * 分两个页面意味着他要跑两趟。这里一次看全，按业务类型可筛。
 */

import { ApprovalBoard } from '@/components/ApprovalBoard';

export function ApprovalCenterPage(): React.ReactElement {
  return (
    <ApprovalBoard
      title="待办与审批"
      description="合同、费用申请、报销单与发票的待办集中在这里；按业务风险等级与提交时间排序"
    />
  );
}

export default ApprovalCenterPage;
